import { PosMode } from '@/features/pos/types'
import { Href, router } from 'expo-router'

const orderFinalizationRouteByMode: Record<PosMode, Href> = {
    pos: '/pos/2-order-finalization',
    phone: '/phone/2-order-finalization',
}

export const navigateToOrderFinalization = (mode: PosMode) =>
    router.navigate(orderFinalizationRouteByMode[mode])
